"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MarkdownLinkRenderer = _interopRequireDefault(require("../../../shared/components/MarkdownRenderers/MarkdownLinkRenderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Hyperlink = function DefaultHyperlink(_ref) {
  var element = _ref.element,
      children = _ref.children,
      currentClass = _ref.currentClass;
  return /*#__PURE__*/_react["default"].createElement(_MarkdownLinkRenderer["default"], {
    href: element.data.url,
    className: currentClass,
    external: element.data.target === '_blank'
  }, children);
};

Hyperlink.propTypes = {
  element: _propTypes["default"].shape({}).isRequired,
  children: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  currentClass: _propTypes["default"].string.isRequired
};
var _default = Hyperlink;
exports["default"] = _default;